import { ActiveLinkType, useProductInput } from './ProductsConfiguration'
import useFormikHelper from './useFormikHelper'
import { useCopyPasteTubeMutation } from '@src/mutations/ConfiguratorTubesMutation.generated'
import messages from '../../messages'
import { useRouter } from '@src/routes'
import { getOligoListFromFileUpload } from './Step1/MultipleProductEntryUtil'

interface UseCopyPasteHelperReturnValues {
  copyPaste: (props?: CopyPasteParams) => Promise<void>
}

interface CopyPasteParams {
  userWantsToContinue: boolean
}

const useCopyPasteHelper = (): UseCopyPasteHelperReturnValues => {
  const formik = useFormikHelper()
  const [copyPasteTube] = useCopyPasteTubeMutation()
  const router = useRouter()
  const productInput = useProductInput()

  const performCopyPaste = (key, value) => {
    if (key && key !== '') {
      if (
        (key === messages.CONF_SUCCESS.defaultMessage ||
          key === messages.CONF_REVIEW_ERROR.defaultMessage) &&
        value
      ) {
        const oligoList = getOligoListFromFileUpload(value)
        formik.setValues({ ...formik.allValues, oligoList })
        // navigate to confirm page
        const { country, language, product } = router.query
        router.replace(
          {
            pathname: router.pathname,
            query: {
              country: country,
              language: language,
              product: product,
              activeLink: ActiveLinkType.ConfirmOrder,
            },
          },
          undefined,
          { shallow: true }
        )
      } else {
        formik.setFieldValue('displayPageError', true, false)
        formik.setFieldValue('validationMessage', [key], false)
        window.scrollTo(0, 0)
      }
    }
  }

  const copyPaste = async (props) => {
    if (
      props?.userWantsToContinue === true ||
      formik?.allValues?.oligoList?.[0].name === ''
    ) {
      formik.setFieldValue('copypasteLoading', true, false)

      const response = await copyPasteTube({
        variables: {
          input: formik.allValues?.copiedEntry || '',
          productInput,
          isOverride: false,
          isDForm: false,
        },
      })
      const { data } = response
      if (data && data.copyPasteTube) {
        if (!data.copyPasteTube.serverError) {
          const { key, value } = data.copyPasteTube
          performCopyPaste(key, value)
        } else {
          formik.setFieldValue('displayPageError', true, false)
        }
      }
      formik.setFieldValue('showCautionPopup', false, false)
      formik.setFieldValue('copypasteLoading', false, false)
    } else {
      formik.setFieldValue('showCautionPopup', true, false)
    }
  }

  return {
    copyPaste,
  }
}

export default useCopyPasteHelper
